import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=42998559&scoped=true&lang=pug&"
import script from "./Space.ts?vue&type=script&lang=ts&"
export * from "./Space.ts?vue&type=script&lang=ts&"
import style0 from "./Space.vue?vue&type=style&index=0&id=42998559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42998559",
  null
  
)

export default component.exports